import { c as _c } from "react/compiler-runtime";
import { HStack, VStack } from "@navikt/ds-react";
import { ExitButton } from "@/shared/components/ExitButton";
import { HeadingLeder } from "@/shared/components/HeadingLeder";
import { InfoDescription } from "@/shared/components/InfoDescription";
import { Lumi } from "@/shared/components/lumi/Lumi";
import { lumiSurveyConfig } from "@/shared/components/lumi/lumiSurveyConfig";
import ThankYouAlert from "@/shared/components/ThankYouAlert";
import { Summary } from "./Summary";
export function SubmitView() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HeadingLeder />;
    t1 = <ThankYouAlert />;
    t2 = <InfoDescription />;
    t3 = <Summary />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <><VStack gap="space-32">{t0}{t1}{t2}{t3}<HStack><ExitButton /></HStack></VStack><Lumi feedbackId="leder-feedback" survey={lumiSurveyConfig} /></>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}